// extracted by mini-css-extract-plugin
export var sliderRange = "_m3-2";
export var sliderRoot = "_m3-0";
export var sliderThumb = "_m3-3";
export var sliderTrack = "_m3-1";